module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img-d1218a02ae99b13ca4d818acaa4aa9fc.png";